import './index.css'
const Heroperson = () => {

    return (
        <div className="containerheroperson">

            <div className="herosection2">
                <h1 className="title">L'école de Poudlard</h1>
               
            </div>


        </div>
    )

}

export default Heroperson